export const PERMISSIONS = [
    "view", "play", "editAnyCharacter", "runGame", "manageInvites", "approveJoins", "claimTonight", "voiceControl",
    "editSettings", "manageRoles", "removeMembers", "deleteCampaign", "restoreCampaign", "takeOver",
];
const STAFF = ["editAnyCharacter", "runGame", "manageInvites", "approveJoins", "claimTonight", "voiceControl"];
export function can(p, who) {
    if (who.admin)
        return true;
    if (!who.role)
        return false;
    if (p === "view" || p === "play")
        return true;
    if (STAFF.includes(p))
        return who.role === "host" || who.role === "cohost";
    return who.role === "host";
}
export const isStaff = (who) => can("runGame", who);
export const ROLE_LABELS = { host: "Host", cohost: "Co-host", player: "Player" };
//# sourceMappingURL=permissions.js.map